export default "__VITE_ASSET__7geQD3GN__"